<template>

    <div class="page white_bg" style="max-width: 425px;">

        <div style="height: 46px;"><!-- set height if pageHeader is fixed position -->
            <header class="pageHeader white_bg lightGreyBottomBorder" style="line-height: 30px;">
                <div class="borderLayout paddingH16 paddingV8">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <i class="icon searchIcon" style="margin-top: 3px;" @click="$refs.searchBar.show()"></i>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

<!--        <searchBar ref="searchBar" @search="onSearch"/>-->

        <div class="body" style="">
            <div class="white_bg" style="border-radius: 16px 16px 0px 0px;">

                <div class="dataList" >
                    <div class="dataRow flexLayout" v-for="bizItem in dataList"
                         :key="bizItem.id" @click="viewItem(bizItem)">
                        <div class="width: 124px;">
                            <div class="imageArea roundBorder8 hiddenOverflow w100p"
                                 style="width: 124px;height: 78px;">
                                <img class="fullSpace cover" :src="bizItem.coverImg" v-if="bizItem.coverImg"/>
                            </div>
                        </div>
                        <div class="flexItem marginL12">
                            <div class="lineHeight21r14f bold font14r grey20 hiddenOverflow" style="
                                height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;">
                                {{bizItem.title}}
                            </div>
                            <div class="font12r grey marginT12">
                                {{bizItem.teacherName}}
<!--                                | 师讯首席讲师-->
                            </div>
                            <div class="bold grey20 marginT12 clearfix">
                                <div class="fl">
                                    <strong class="font12r red">￥</strong>
                                    <strong class="red">{{bizItem.price}}</strong>
                                    <span class="grey20 font12r" v-show="bizItem.liveCount">
                                        /共{{bizItem.liveCount}}节
                                    </span>
                                </div>
                                <div class="fr grey font12r">
                                    {{bizItem.applyCount}}人在学
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'ready' && dataList.length < 1">
                        暂无任何课程
                    </div>

                    <div class="paddingV16 alignCenter font14r colorCCC"
                         v-show="dataList.length && pagination.current == pagination.totalPage"
                         :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                        没有更多课程了
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'error'">
                        加载数据失败
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

import consoleApi       from '@/components/platformApi/consoleApi';

// modules
import searchBar        from "@/components/search/searchBar";

// util
import appHelper        from '@/util/appHelper';
import routeHelper      from "@util/routeHelper";
import dataMixedUtils from "@util/dataMixedUtils";

const config = {
    name : 'indexCourseList',
    title : '课程列表',
    description : appConfig.name + ' - ' + appConfig.desc,
    apiConfig : {
        list : {
            url : 'portal/v4/index/bizGroup',
            dataPath : 'data.bizList.records',
            totalPagePath : 'data.bizList.pages',
            params : {
                size : 100
            }
        },
        get : {
            url : 'portal/v4/index/bizGroup',
            dataPath : 'data',
            params : {
                size : 100
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        searchBar,
    },
    data () {
        return {
            name : config.name,
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataList : true,

            enableDataItem : true,
            autoLoadDataItem : true,

            searchInputbox : {
                column : 'title'
            },

            list : []
        }
    },
    methods : {

        onLoadDataItem() {
            this.title = this.topicName = this.dataItem.title;
            appHelper.setTitle(this.topicName);
            this.setWechatShare();

            this.apiConfig.list.params = {
                id : this.dataItem.id
            };
            this.loadDataList();
        },
        // onLoadDataList() {
        //
        //     if (this.dataList.length)
        //     {
        //         this.topicName              = this.dataList[0].topicName;
        //         this.pagination.totalPage   = this.dataList[this.dataList.length - 1].bizData.pages;
        //         let list    = this.dataList[this.dataList.length - 1].bizData.records;
        //         this.list   = dataMixedUtils.array.merge(this.list, list);
        //
        //         this.title = this.topicName;
        //         appHelper.setTitle(this.topicName);
        //         this.setWechatShare();
        //     }
        // },

        viewItem(dataItem) {
            appHelper.goToPage('courseDetail', {
                id : dataItem.id
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.lightGrey {
    color: hsla(219, 16%, 60%, 1);
}
.grey {
    color: hsla(219, 9%, 39%, 1);
}
.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.dataList {
    .dataRow {
        padding: 21px 16px 11px;
    }
}
</style>
